(function () {
  if (customElements.get('sk-bundle-builder')) return;

  class SkBundleBuilder extends HTMLElement {
    constructor() {
      super();
      this.giftVariants = {};
      this.resyncTimer = null;
      this.moneyFormat = (window.Shopify && window.Shopify.money_format) || '€{{amount_with_comma_separator}}';
    }

    connectedCallback() {
      this.gift30Variant = Number(this.dataset.tier1Variant);
      this.gift30Threshold = Number(this.dataset.tier1Threshold);
      this.gift75Variant = Number(this.dataset.tier2Variant);
      this.gift75Threshold = Number(this.dataset.tier2Threshold);
      this.shippingThreshold = Number(this.dataset.shippingThreshold);
      this.giftVariantIds = [this.gift30Variant, this.gift75Variant];

      this.cacheDom();
      this.bindEvents();
      this.refresh(true);
    }

    cacheDom() {
      this.tabs = Array.from(this.querySelectorAll('[data-tab-target]'));
      this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));
      this.ctas = Array.from(this.querySelectorAll('[data-cta]'));
      this.itemsList = this.querySelector('[data-items-list]');
      this.progressFills = Array.from(this.querySelectorAll('[data-progress-fill]'));
      this.unlockTextEls = Array.from(this.querySelectorAll('[data-unlock-text]'));
      this.subtotalEls = Array.from(this.querySelectorAll('[data-subtotal-price]'));
      this.shippingEls = Array.from(this.querySelectorAll('[data-shipping-row]'));
      this.totalEls = Array.from(this.querySelectorAll('[data-total-price-2]'));
      this.peekTotalEls = Array.from(this.querySelectorAll('[data-total-price-3]'));
      this.itemCountEls = Array.from(this.querySelectorAll('[data-item-count]'));
      this.checkoutBtns = Array.from(this.querySelectorAll('[data-checkout-btn]'));
      this.milestoneEls = Array.from(this.querySelectorAll('[data-milestone]'));
      this.form = this.querySelector('[data-bundle-form]');
      this.formToggle = this.querySelector('[data-form-toggle]');
      this.formClose = this.querySelector('[data-form-close]');
      this.overlay = this.querySelector('[data-form-overlay]');
    }

    bindEvents() {
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.switchTab(tab));
      });

      this.ctas.forEach((cta) => {
        const variantId = Number(cta.dataset.variantId);
        const addBtn = cta.querySelector('[data-add-btn]');
        const minus = cta.querySelector('[data-qty-minus]');
        const plus = cta.querySelector('[data-qty-plus]');

        addBtn.addEventListener('click', () => {
          this.addToCart(variantId, 1);
        });

        plus.addEventListener('click', () => {
          this.changeQuantity(variantId, 1);
        });

        minus.addEventListener('click', () => {
          this.changeQuantity(variantId, -1);
        });
      });

      this.checkoutBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          if (btn.disabled) return;
          window.location.href = '/checkout';
        });
      });

      if (this.formToggle) {
        this.formToggle.addEventListener('click', () => this.toggleDrawer(true));
      }
      if (this.formClose) {
        this.formClose.addEventListener('click', () => this.toggleDrawer(false));
      }
      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.toggleDrawer(false));
      }
    }

    switchTab(tab) {
      this.tabs.forEach((t) => {
        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');
      });
      tab.classList.add('active');
      tab.setAttribute('aria-selected', 'true');

      const targetId = tab.dataset.tabTarget;
      this.panels.forEach((panel) => {
        panel.classList.toggle('hidden', panel.id !== targetId);
      });
    }

    toggleDrawer(force) {
      const willOpen = typeof force === 'boolean' ? force : !this.form.classList.contains('active');
      this.form.classList.toggle('active', willOpen);
      this.overlay.classList.toggle('active', willOpen);
      document.body.classList.toggle('sk-bundle-drawer-open', willOpen);
    }

    async addToCart(variantId, quantity) {
      const cta = this.ctas.find((c) => Number(c.dataset.variantId) === variantId);
      const btn = cta ? cta.querySelector('[data-add-btn]') : null;
      if (btn) btn.disabled = true;
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: String(variantId), quantity }] }),
        });
        await this.refresh(false);
        this.scheduleResync();
      } catch (err) {
        console.error('[SK Bundle] add error', err);
      } finally {
        if (btn) btn.disabled = false;
      }
    }

    async changeQuantity(variantId, delta) {
      const current = this.cartQuantities ? (this.cartQuantities[variantId] || 0) : 0;
      const next = Math.max(0, current + delta);
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: String(variantId), quantity: next }),
        });
        await this.refresh(false);
        this.scheduleResync();
      } catch (err) {
        console.error('[SK Bundle] change error', err);
      }
    }

    scheduleResync() {
      clearTimeout(this.resyncTimer);
      this.resyncTimer = setTimeout(() => this.refresh(false), 1000);
    }

    async refresh(isInitial) {
      const cart = await fetch('/cart.js').then((r) => r.json());
      this.cartQuantities = {};
      cart.items.forEach((item) => {
        this.cartQuantities[item.variant_id] = item.quantity;
      });

      this.updateGrid(cart);
      this.updateSidebar(cart);

      if (isInitial) {
        setTimeout(() => this.refresh(false), 900);
      }
    }

    updateGrid(cart) {
      this.ctas.forEach((cta) => {
        const variantId = Number(cta.dataset.variantId);
        const item = cart.items.find((i) => Number(i.variant_id) === variantId);
        const addBtn = cta.querySelector('[data-add-btn]');
        const qtyControls = cta.querySelector('[data-qty-controls]');
        const qtyNumber = cta.querySelector('[data-qty-number]');

        if (item) {
          addBtn.hidden = true;
          qtyControls.hidden = false;
          qtyNumber.textContent = item.quantity;
        } else {
          addBtn.hidden = false;
          qtyControls.hidden = true;
        }
      });
    }

    updateSidebar(cart) {
      const bundleVariantIds = this.ctas.map((c) => Number(c.dataset.variantId));
      // Gift lines (auto-added elsewhere on the site) are intentionally excluded
      // from this list/count — the bundle builder only shows what the customer picked here.
      const bundleItems = cart.items.filter((i) => bundleVariantIds.includes(Number(i.variant_id)));
      const bundleSubtotalCents = bundleItems.reduce((sum, i) => sum + i.final_line_price, 0);

      // Milestones/unlock text match the real cart-wide logic in skintone-gifts.js
      // (whole cart minus the gift SKUs), so a customer who already has other
      // items in their cart sees accurate unlock states here too.
      const subtotalCents = cart.items
        .filter((i) => !this.giftVariantIds.includes(Number(i.variant_id)))
        .reduce((sum, i) => sum + i.final_line_price, 0);

      const unlockMessage = this.getUnlockMessage(subtotalCents);

      // Render item rows: filled items first, then placeholder slots (min 3 total, min 1 placeholder)
      this.itemsList.innerHTML = '';

      bundleItems.forEach((item) => {
        const row = document.createElement('div');
        row.className = 'sk-bundle__item sk-bundle__item--filled';
        row.innerHTML = `
          <div class="sk-bundle__item-image">
            <img src="${item.image ? item.image.replace(/(\.[^./?]+)(\?.*)?$/, '_200x$1$2') : ''}" alt="" loading="lazy">
          </div>
          <div class="sk-bundle__item-details">
            <span class="sk-bundle__item-title">${item.product_title}</span>
            <span class="sk-bundle__item-price">${this.formatMoney(item.final_line_price)}</span>
          </div>
          <button type="button" class="sk-bundle__item-remove" aria-label="Verwijder"><svg viewBox="0 0 20 20" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 4l12 12M16 4L4 16"/></svg></button>
        `;
        row.querySelector('.sk-bundle__item-remove').addEventListener('click', () => {
          this.changeQuantity(Number(item.variant_id), -item.quantity);
        });
        this.itemsList.appendChild(row);
      });

      const placeholderCount = Math.max(3 - bundleItems.length, 1);
      for (let i = 0; i < placeholderCount; i++) {
        const row = document.createElement('div');
        row.className = 'sk-bundle__item sk-bundle__item--empty';
        row.innerHTML = `
          <div class="sk-bundle__item-placeholder"><svg viewBox="0 0 20 20" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M10 3v14M3 10h14"/></svg></div>
          <span class="sk-bundle__item-add-text">${unlockMessage}</span>
        `;
        this.itemsList.appendChild(row);
      }

      // Progress bar (all instances: mobile peek + panel).
      // Milestones sit at fixed, evenly-spaced positions (8% / 50% / 92%) rather
      // than positions proportional to their euro amount, so the fill is mapped
      // through the same anchor points instead of a straight subtotal/max ratio.
      const pct = this.getProgressPosition(subtotalCents);
      this.progressFills.forEach((el) => { el.style.width = pct + '%'; });

      this.milestoneEls.forEach((el) => {
        const amount = Number(el.dataset.milestone) * 100;
        el.classList.toggle('active', subtotalCents >= amount);
      });

      this.unlockTextEls.forEach((el) => { el.textContent = unlockMessage; });

      // Pricing summary
      const shippingFree = subtotalCents >= this.shippingThreshold;
      const shippingCents = 695;
      this.shippingEls.forEach((el) => {
        el.innerHTML = shippingFree
          ? `<span class="sk-bundle__strike">${this.formatMoney(shippingCents)}</span> GRATIS`
          : this.formatMoney(shippingCents);
      });
      const totalCents = bundleSubtotalCents + (shippingFree || bundleItems.length === 0 ? 0 : shippingCents);

      this.subtotalEls.forEach((el) => { el.textContent = this.formatMoney(bundleSubtotalCents); });
      this.totalEls.forEach((el) => { el.textContent = this.formatMoney(totalCents); });
      this.peekTotalEls.forEach((el) => { el.textContent = this.formatMoney(bundleSubtotalCents); });

      if (this.itemCountEls.length) {
        const count = bundleItems.reduce((s, i) => s + i.quantity, 0);
        this.itemCountEls.forEach((el) => { el.textContent = count; });
      }

      this.checkoutBtns.forEach((btn) => {
        btn.disabled = bundleItems.length === 0;
      });
    }

    getProgressPosition(subtotalCents) {
      // Anchor points must match the milestone "left" positions in sk-bundle-progress.liquid.
      const anchors = [
        { cents: 0, pos: 0 },
        { cents: this.shippingThreshold, pos: 8 },
        { cents: this.gift30Threshold, pos: 50 },
        { cents: this.gift75Threshold, pos: 92 },
      ];
      if (subtotalCents >= this.gift75Threshold) return 100;
      for (let i = 0; i < anchors.length - 1; i++) {
        const a = anchors[i];
        const b = anchors[i + 1];
        if (subtotalCents >= a.cents && subtotalCents < b.cents) {
          const ratio = (subtotalCents - a.cents) / (b.cents - a.cents);
          return a.pos + ratio * (b.pos - a.pos);
        }
      }
      return 0;
    }

    getUnlockMessage(subtotalCents) {
      if (subtotalCents >= this.gift75Threshold) {
        return 'Je hebt alle cadeaus ontgrendeld! 🎉';
      }
      if (subtotalCents >= this.gift30Threshold) {
        const remaining = this.gift75Threshold - subtotalCents;
        return `Nog ${this.formatMoney(remaining)} tot een gratis Make-up Tas`;
      }
      if (subtotalCents >= this.shippingThreshold) {
        const remaining = this.gift30Threshold - subtotalCents;
        return `Nog ${this.formatMoney(remaining)} tot een gratis Hyaluronzuur Serum`;
      }
      const remaining = this.shippingThreshold - subtotalCents;
      return `Nog ${this.formatMoney(remaining)} tot gratis verzending`;
    }

    formatMoney(cents) {
      const amount = (cents / 100).toFixed(2).replace('.', ',');
      return '€' + amount;
    }
  }

  customElements.define('sk-bundle-builder', SkBundleBuilder);
})();
